import { LEVELS, TYPES } from '../Const';

export const CKMapping = {
  totalAssets: 'bsa53',
  currentAssets: 'bsa1',
  shorttermFinancialAssets: 'bss214',
  cashAndCashEquivalents: 'bsa2',
  cash: 'bsa3',
  cashEquivalents: 'bsa4',
  shorttermInvestments: 'bsa5',
  shorttermInvestmets: 'bsa6',
  heldtomaturityInvestment: 'bsb108',
  loans: 'bss215',
  availableForSalesAssets: 'bss216',
  provisionForDiminution: 'bsa7',
  accountsReceivables: 'bsa8',
  receivablesFrom: 'bss217',
  tradeAccountsReceivable: 'bsa9',
  deductibleValueAddedTax: 'bss223',
  receivablesFromServicesProvidedByTheSecurities: 'bss224',
  prepaymentsToSuppliers: 'bsa10',
  intercompanyReceivables: 'bsa11',
  receivablesAriseFromTransactionErrors: 'bss225',
  receivableFromTradingStocks: 'bss133',
  constructionContractInProgress: 'bsa12',
  shorttermLoansReceivables: 'bsa159',
  otherReceivables: 'bsa13',
  provisionForShorttermReceivables: 'bss226',
  ProvisionForDoubtfulDebts: 'bsa14',
  ShortageOfCurrentAssetsWatitingForSolution: 'bsi141',
  inventoriesNet: 'bsa15',
  inventories: 'bsa16',
  provisionForDeclineInInventories: 'bsa17',
  otherCurrentAssets: 'bsa18',
  advancePayment: 'bss227',
  toolsAndEquipments: 'bss228',
  shorttermPrepayments: 'bsa19',
  shorttermCollaterals: 'bss229',
  vatToBeClaimed: 'bsa20',
  otherTaxesReceivables: 'bsa21',
  governmentBondsPurchasedForResales: 'bsa160',
  otherCurrentAssets_38: 'bsa22',
  provisionForOtherCurrentAssets: 'bss230',
  longtermAssets: 'bsa23',
  longtermFinancialAssets: 'bss231',
  longtermTradeReceivables: 'bsa24',
  longtermTradeReceivables_43: 'bsa25',
  longtermPrepaymentsToSuppliers: 'bsa161',
  paidinCapitalInWhollyownedSubsidiaries: 'bss134',
  longtermIntercompanyReceivables: 'bsa26',
  longtermLoansReceivables: 'bsa162',
  otherLongtermReceivables: 'bsa27',
  provisionForDoubtfulLongtermReceivables: 'bsa28',
  longtermInvestments: 'bsa43',
  investmentsInSubsidiaries: 'bsa44',
  investmentsInAssociates: 'bsa45',
  longtermSecuritiesInvestment: 'bss189',
  otherLongtermInvestment: 'bsa46',
  provisionForLongtermInvestments: 'bsa47',
  fixedAssets: 'bsa29',
  tangibleFixedAssets: 'bsa30',
  cost: 'bsa31',
  accumulatedDepreciation: 'bsa32',
  RevaluationOfTangibleFixedAssetsUsingFairValueModel: 'bss232',
  financeLeaseAssets: 'bsa33',
  cost_62: 'bsa34',
  accumulatedDepreciation_63: 'bsa35',
  RevaluationOfTangibleFixedAssetsUsingFairValueModel_64: 'bss233',
  intangibleFixedAssets: 'bsa36',
  cost_66: 'bsa37',
  accumulatedDepreciation_67: 'bsa38',
  RevaluationOfTangibleFixedAssetsUsingFairValueModel_68: 'bss234',
  constructionInProgressBefore: 'bsa39',
  investmentProperties: 'bsa40',
  cost_71: 'bsa41',
  accumulatedDepreciation_72: 'bsa42',
  revaluationOfInvestmentPropertyUsingFairValueModel: 'bss235',
  longtermIncompleteAssets: 'bsa163',
  longtermCostOfWorkInProgress: 'bsa164',
  constructinInProgress: 'bsa188',
  otherLongtermAssets: 'bsa49',
  longtermCollaterals: 'bss236',
  longtermPrepayments: 'bsa50',
  deferredIncomeTaxAssets: 'bsa51',
  longtermEquipmentMaterialAndSpareParts: 'bsa166',
  paymentsToSettlementAssistanceFund: 'bss212',
  otherLongtermAssets_83: 'bsa52',
  goodwill: 'bsa209',
  provisionForLongTermAssets: 'bss237',
  liabilities: 'bsa54',
  currentLiabilities: 'bsa55',
  shorttermLoans: 'bsa56',
  shorttermLoans_89: 'bss238',
  shorttermFinanceLease: 'bss239',
  shorttermFinancialAssets_91: 'bss240',
  shorttermConvertibleBonds: 'bss241',
  shorttermBondsIssued: 'bss242',
  loansFromPayableAssistanceFund: 'bss243',
  payablesToSecuritiesTrading: 'bss135',
  payableAriseFromTransactionErrors: 'bss244',
  tradeAccountsPayable: 'bsa57',
  advancesFromCustomers: 'bsa58',
  taxesAndOtherPayableToStateBudget: 'bsa59',
  payableToEmployees: 'bsa60',
  employeesWelfarePayableToAuthorities: 'bss245',
  accruedExpenses: 'bsa61',
  intercompanyPayables: 'bsa62',
  shorttermUnrealizedRevenue: 'bsa167',
  shorttermCollateralsReceivables: 'bss246',
  constructionContractInProgress_106: 'bsa63',
  dividendPrincipalAndInterestsPayables: 'bss136',
  payablesToSecuritiesIssues: 'bss137',
  otherPayables: 'bsa64',
  provisionForShorttermLiabilities: 'bsa65',
  bonusAndWelfareFunds: 'bsa66',
  priceStabilizationFund: 'bsa168',
  governmentBondsPurchasedForResale: 'bsa169',
  longtermLiabilities: 'bsa67',
  LongtermLoans: 'bsa71',
  LongtermLoans_116: 'bss247',
  LongtermFinanceLease: 'bss248',
  longtermFinancialAssetsLoans: 'bss249',
  convertibleBonds: 'bsa173',
  longtermBonds: 'bss250',
  longtermTradePayables: 'bsa68',
  longtermAdvancesFromCustomers: 'bsa170',
  longtermAccruedExpenses: 'bsa171',
  longtermIntercompanyPayables: 'bsa69',
  intracompanyPayablesForOperatingCapitalReceived: 'bsa172',
  deferredRevenue: 'bsa76',
  longtermCollateralsReceived: 'bss251',
  otherLongtermPayables: 'bsa70',
  preferredShares: 'bsa174',
  provisionForSeveranceAllowances: 'bsa73',
  provisionForLongtermLiabilities: 'bsa74',
  provisionForCompensationOfInvestors: 'bss138',
  DeferredIncomeTaxLiabilities: 'bsa72',
  technologyscienceDevelopmentFund: 'bsa77',
  ownersEquity: 'bsa78',
  capitalAndReserves: 'bsa79',
  sharholdersEquity: 'bss252',
  paidinCapital: 'bsa80',
  capitalSurplus: 'bsa81',
  conversionOptionsOnConvertibleBonds: 'bsa176',
  ownersOtherCapital: 'bsa82',
  treasuryShares: 'bsa83',
  differencesUponAssetRevaluation: 'bsa84',
  foreignExchangeDifferences: 'bsa85',
  charterReserve: 'bss253',
  investmentAndDevelopment: 'bsa86',
  financialReserveFunds: 'bsa87',
  otherFunds: 'bsa89',
  undistributedEarnings: 'bsa90',
  realizedGain: 'bss254',
  unrealizedGain: 'bss255',
  minorityInterest: 'bsa210',
  budgetSourcesAndOtherFunds: 'bsa92',
  bonusAndWelfareFundsBefore: 'bsa93',
  budgetSourcesAndOtherFunds_155: 'bsa94',
  fundsUsedForFixedAssetAcquisitions: 'bsa211',
  minorityInterestBefore: 'bsa95',
  totalResources: 'bsa96',
  distributedProfitToInvestor: 'bss256',
  distributedProfitToInvestorDuringTheYear: 'bss257',
};

export const BalanceSheetCKRows = [
  {
    id: 'chart',
    type: TYPES.CHART,
    level: LEVELS.PARENT,
  },
].concat(
  Object.keys(CKMapping).map(key => {
    const mappingValue = CKMapping[key];
    const defaultItem = {
      id: mappingValue,
      i18nKey: `BalanceSheetCK.${key}`,
      level: LEVELS.PARENT,
    };

    if (
      [
        CKMapping.totalAssets,
        CKMapping.currentAssets,
        CKMapping.longtermAssets,
        CKMapping.provisionForLongTermAssets,
        CKMapping.liabilities,
        CKMapping.ownersEquity,
        CKMapping.minorityInterestBefore,
        CKMapping.totalResources,
        CKMapping.distributedProfitToInvestor,
        CKMapping.distributedProfitToInvestorDuringTheYear,
      ].includes(mappingValue)
    ) {
      return defaultItem;
    }

    if (CKMapping.shorttermFinancialAssets === mappingValue) {
      return {
        ...defaultItem,
        children: [
          CKMapping.cashAndCashEquivalents,
          CKMapping.shorttermInvestments,
          CKMapping.accountsReceivables,
          CKMapping.inventoriesNet,
        ],
      };
    }

    if (CKMapping.cashAndCashEquivalents === mappingValue) {
      return {
        ...defaultItem,
        level: LEVELS.CHILD,
        children: [CKMapping.cash, CKMapping.cashEquivalents],
      };
    }

    if (CKMapping.shorttermInvestments === mappingValue) {
      return {
        ...defaultItem,
        level: LEVELS.CHILD,
        children: [
          CKMapping.shorttermInvestmets,
          CKMapping.heldtomaturityInvestment,
          CKMapping.loans,
          CKMapping.availableForSalesAssets,
          CKMapping.provisionForDiminution,
        ],
      };
    }

    if (CKMapping.accountsReceivables === mappingValue) {
      return {
        ...defaultItem,
        level: LEVELS.CHILD,
        children: [
          CKMapping.receivablesFrom,
          CKMapping.tradeAccountsReceivable,
          CKMapping.deductibleValueAddedTax,
          CKMapping.receivablesFromServicesProvidedByTheSecurities,
          CKMapping.prepaymentsToSuppliers,
          CKMapping.intercompanyReceivables,
          CKMapping.receivablesAriseFromTransactionErrors,
          CKMapping.receivableFromTradingStocks,
          CKMapping.constructionContractInProgress,
          CKMapping.shorttermLoansReceivables,
          CKMapping.otherReceivables,
          CKMapping.provisionForShorttermReceivables,
          CKMapping.ProvisionForDoubtfulDebts,
          CKMapping.ShortageOfCurrentAssetsWatitingForSolution,
        ],
      };
    }

    if (CKMapping.inventoriesNet === mappingValue) {
      return {
        ...defaultItem,
        level: LEVELS.CHILD,
        children: [
          CKMapping.inventories,
          CKMapping.provisionForDeclineInInventories,
        ],
      };
    }

    if (CKMapping.otherCurrentAssets === mappingValue) {
      return {
        ...defaultItem,
        children: [
          CKMapping.advancePayment,
          CKMapping.toolsAndEquipments,
          CKMapping.shorttermPrepayments,
          CKMapping.shorttermCollaterals,
          CKMapping.vatToBeClaimed,
          CKMapping.otherTaxesReceivables,
          CKMapping.governmentBondsPurchasedForResales,
          CKMapping.otherCurrentAssets_38,
          CKMapping.provisionForOtherCurrentAssets,
        ],
      };
    }

    if (CKMapping.longtermFinancialAssets === mappingValue) {
      return {
        ...defaultItem,
        children: [
          CKMapping.longtermTradeReceivables,
          CKMapping.longtermInvestments,
        ],
      };
    }

    if (CKMapping.longtermTradeReceivables === mappingValue) {
      return {
        ...defaultItem,
        level: LEVELS.CHILD,
        children: [
          CKMapping.longtermTradeReceivables_43,
          CKMapping.longtermPrepaymentsToSuppliers,
          CKMapping.paidinCapitalInWhollyownedSubsidiaries,
          CKMapping.longtermIntercompanyReceivables,
          CKMapping.longtermLoansReceivables,
          CKMapping.otherLongtermReceivables,
          CKMapping.provisionForDoubtfulLongtermReceivables,
        ],
      };
    }

    if (CKMapping.longtermInvestments === mappingValue) {
      return {
        ...defaultItem,
        level: LEVELS.CHILD,
        children: [
          CKMapping.investmentsInSubsidiaries,
          CKMapping.investmentsInAssociates,
          CKMapping.longtermSecuritiesInvestment,
          CKMapping.otherLongtermInvestment,
          CKMapping.provisionForLongtermInvestments,
        ],
      };
    }

    if (CKMapping.fixedAssets === mappingValue) {
      return {
        ...defaultItem,
        children: [
          CKMapping.tangibleFixedAssets,
          CKMapping.financeLeaseAssets,
          CKMapping.intangibleFixedAssets,
          CKMapping.constructionInProgressBefore,
        ],
      };
    }

    if (CKMapping.tangibleFixedAssets === mappingValue) {
      return {
        ...defaultItem,
        level: LEVELS.CHILD,
        children: [
          CKMapping.cost,
          CKMapping.accumulatedDepreciation,
          CKMapping.RevaluationOfTangibleFixedAssetsUsingFairValueModel,
        ],
      };
    }

    if (CKMapping.financeLeaseAssets === mappingValue) {
      return {
        ...defaultItem,
        level: LEVELS.CHILD,
        children: [
          CKMapping.cost_62,
          CKMapping.accumulatedDepreciation_63,
          CKMapping.RevaluationOfTangibleFixedAssetsUsingFairValueModel_64,
        ],
      };
    }

    if (CKMapping.intangibleFixedAssets === mappingValue) {
      return {
        ...defaultItem,
        level: LEVELS.CHILD,
        children: [
          CKMapping.cost_66,
          CKMapping.accumulatedDepreciation_67,
          CKMapping.RevaluationOfTangibleFixedAssetsUsingFairValueModel_68,
        ],
      };
    }

    if (CKMapping.investmentProperties === mappingValue) {
      return {
        ...defaultItem,
        children: [
          CKMapping.cost_71,
          CKMapping.accumulatedDepreciation_72,
          CKMapping.revaluationOfInvestmentPropertyUsingFairValueModel,
        ],
      };
    }

    if (CKMapping.longtermIncompleteAssets === mappingValue) {
      return {
        ...defaultItem,
        children: [
          CKMapping.longtermCostOfWorkInProgress,
          CKMapping.constructinInProgress,
        ],
      };
    }

    if (CKMapping.otherLongtermAssets === mappingValue) {
      return {
        ...defaultItem,
        children: [
          CKMapping.longtermCollaterals,
          CKMapping.longtermPrepayments,
          CKMapping.deferredIncomeTaxAssets,
          CKMapping.longtermEquipmentMaterialAndSpareParts,
          CKMapping.paymentsToSettlementAssistanceFund,
          CKMapping.otherLongtermAssets_83,
          CKMapping.goodwill,
        ],
      };
    }

    if (CKMapping.currentLiabilities === mappingValue) {
      return {
        ...defaultItem,
        children: [
          CKMapping.shorttermLoans,
          CKMapping.shorttermFinancialAssets_91,
          CKMapping.shorttermConvertibleBonds,
          CKMapping.shorttermBondsIssued,
          CKMapping.loansFromPayableAssistanceFund,
          CKMapping.payablesToSecuritiesTrading,
          CKMapping.payableAriseFromTransactionErrors,
          CKMapping.tradeAccountsPayable,
          CKMapping.advancesFromCustomers,
          CKMapping.taxesAndOtherPayableToStateBudget,
          CKMapping.payableToEmployees,
          CKMapping.employeesWelfarePayableToAuthorities,
          CKMapping.accruedExpenses,
          CKMapping.intercompanyPayables,
          CKMapping.shorttermUnrealizedRevenue,
          CKMapping.shorttermCollateralsReceivables,
          CKMapping.constructionContractInProgress_106,
          CKMapping.dividendPrincipalAndInterestsPayables,
          CKMapping.payablesToSecuritiesIssues,
          CKMapping.otherPayables,
          CKMapping.provisionForShorttermLiabilities,
          CKMapping.bonusAndWelfareFunds,
          CKMapping.priceStabilizationFund,
          CKMapping.governmentBondsPurchasedForResale,
        ],
      };
    }

    if (CKMapping.shorttermLoans === mappingValue) {
      return {
        ...defaultItem,
        level: LEVELS.CHILD,
        children: [
          CKMapping.shorttermLoans_89,
          CKMapping.shorttermFinanceLease,
        ],
      };
    }

    if (CKMapping.longtermLiabilities === mappingValue) {
      return {
        ...defaultItem,
        children: [
          CKMapping.LongtermLoans,
          CKMapping.longtermFinancialAssetsLoans,
          CKMapping.convertibleBonds,
          CKMapping.longtermBonds,
          CKMapping.longtermTradePayables,
          CKMapping.longtermAdvancesFromCustomers,
          CKMapping.longtermAccruedExpenses,
          CKMapping.longtermIntercompanyPayables,
          CKMapping.intracompanyPayablesForOperatingCapitalReceived,
          CKMapping.deferredRevenue,
          CKMapping.longtermCollateralsReceived,
          CKMapping.otherLongtermPayables,
          CKMapping.preferredShares,
          CKMapping.provisionForSeveranceAllowances,
          CKMapping.provisionForCompensationOfInvestors,
          CKMapping.DeferredIncomeTaxLiabilities,
          CKMapping.technologyscienceDevelopmentFund,
        ],
      };
    }

    if (CKMapping.LongtermLoans === mappingValue) {
      return {
        ...defaultItem,
        level: LEVELS.CHILD,
        children: [CKMapping.LongtermLoans_116, CKMapping.LongtermFinanceLease],
      };
    }

    if (CKMapping.capitalAndReserves === mappingValue) {
      return {
        ...defaultItem,
        children: [
          CKMapping.sharholdersEquity,
          CKMapping.differencesUponAssetRevaluation,
          CKMapping.foreignExchangeDifferences,
          CKMapping.charterReserve,
          CKMapping.investmentAndDevelopment,
          CKMapping.financialReserveFunds,
          CKMapping.otherFunds,
          CKMapping.undistributedEarnings,
          CKMapping.minorityInterest,
        ],
      };
    }

    if (CKMapping.sharholdersEquity === mappingValue) {
      return {
        ...defaultItem,
        level: LEVELS.CHILD,
        children: [
          CKMapping.paidinCapital,
          CKMapping.capitalSurplus,
          CKMapping.conversionOptionsOnConvertibleBonds,
          CKMapping.ownersOtherCapital,
          CKMapping.treasuryShares,
        ],
      };
    }

    if (CKMapping.undistributedEarnings === mappingValue) {
      return {
        ...defaultItem,
        level: LEVELS.CHILD,
        children: [CKMapping.realizedGain, CKMapping.unrealizedGain],
      };
    }

    if (CKMapping.budgetSourcesAndOtherFunds === mappingValue) {
      return {
        ...defaultItem,
        children: [
          CKMapping.bonusAndWelfareFundsBefore,
          CKMapping.budgetSourcesAndOtherFunds_155,
          CKMapping.fundsUsedForFixedAssetAcquisitions,
        ],
      };
    }

    if (
      [
        CKMapping.realizedGain,
        CKMapping.unrealizedGain,
        CKMapping.paidinCapital,
        CKMapping.capitalSurplus,
        CKMapping.conversionOptionsOnConvertibleBonds,
        CKMapping.ownersOtherCapital,
        CKMapping.treasuryShares,
        CKMapping.LongtermLoans_116,
        CKMapping.LongtermFinanceLease,
        CKMapping.shorttermLoans_89,
        CKMapping.shorttermFinanceLease,
        CKMapping.cost_66,
        CKMapping.accumulatedDepreciation_67,
        CKMapping.RevaluationOfTangibleFixedAssetsUsingFairValueModel_68,
        CKMapping.cash,
        CKMapping.cashEquivalents,
        CKMapping.shorttermInvestmets,
        CKMapping.heldtomaturityInvestment,
        CKMapping.loans,
        CKMapping.availableForSalesAssets,
        CKMapping.provisionForDiminution,
        CKMapping.receivablesFrom,
        CKMapping.tradeAccountsReceivable,
        CKMapping.deductibleValueAddedTax,
        CKMapping.receivablesFromServicesProvidedByTheSecurities,
        CKMapping.prepaymentsToSuppliers,
        CKMapping.intercompanyReceivables,
        CKMapping.receivablesAriseFromTransactionErrors,
        CKMapping.receivableFromTradingStocks,
        CKMapping.constructionContractInProgress,
        CKMapping.shorttermLoansReceivables,
        CKMapping.otherReceivables,
        CKMapping.provisionForShorttermReceivables,
        CKMapping.ProvisionForDoubtfulDebts,
        CKMapping.ShortageOfCurrentAssetsWatitingForSolution,
        CKMapping.longtermTradeReceivables_43,
        CKMapping.longtermPrepaymentsToSuppliers,
        CKMapping.paidinCapitalInWhollyownedSubsidiaries,
        CKMapping.longtermIntercompanyReceivables,
        CKMapping.longtermLoansReceivables,
        CKMapping.otherLongtermReceivables,
        CKMapping.provisionForDoubtfulLongtermReceivables,
        CKMapping.investmentsInSubsidiaries,
        CKMapping.investmentsInAssociates,
        CKMapping.longtermSecuritiesInvestment,
        CKMapping.otherLongtermInvestment,
        CKMapping.provisionForLongtermInvestments,
        CKMapping.cost,
        CKMapping.accumulatedDepreciation,
        CKMapping.RevaluationOfTangibleFixedAssetsUsingFairValueModel,
        CKMapping.cost_62,
        CKMapping.accumulatedDepreciation_63,
        CKMapping.RevaluationOfTangibleFixedAssetsUsingFairValueModel_64,
        CKMapping.inventories,
        CKMapping.provisionForDeclineInInventories,
      ].includes(mappingValue)
    ) {
      return {
        ...defaultItem,
        level: LEVELS.THREE,
      };
    }

    return {
      ...defaultItem,
      level: LEVELS.CHILD,
    };
  }),
);

export const balanceSheetCKChartTitles = [
  {
    key: 'currentAssets',
    color: '#e5efc1',
    i18nKey: 'financialStatement.BalanceSheetCK.currentAssets',
  },
  {
    key: 'tangibleFixedAssets',
    color: '#a2d5ab',
    i18nKey: 'financialStatement.BalanceSheetCK.tangibleFixedAssets',
  },
  {
    key: 'intangibleFixedAssets',
    color: '#3baea9',
    i18nKey: 'financialStatement.BalanceSheetCK.intangibleFixedAssets',
  },
  {
    key: 'otherAssets',
    color: '#358bbc',
    i18nKey: 'financialStatement.BalanceSheetCK.otherAssets',
  },
  {
    key: 'currentLiabilities',
    color: '#f8b195',
    i18nKey: 'financialStatement.BalanceSheetCK.currentLiabilities',
  },
  {
    key: 'longTermLiabilities',
    color: '#f27280',
    i18nKey: 'financialStatement.BalanceSheetCK.longTermLiabilities',
  },
  {
    key: 'shareholderEquity',
    color: '#b76880',
    i18nKey: 'financialStatement.BalanceSheetCK.shareholdersEquity',
  },
  {
    key: 'minorityInterestBefore',
    color: '#6c5c7c',
    i18nKey: 'financialStatement.BalanceSheetCK.minorityInterestBefore',
  },
];
